<template>
  <main class="col-span-2 grid overflow-hidden">
    <slot></slot>
  </main>
</template>
